module.exports = __webpack_public_path__ + "img/public_resources_arrow_last_active.cef685b9.svg";